<div class="table-container">
    <aside class="locked">
        <table>
            <thead>
                <tr>
                    <th> </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of overview.rows; index as i">
                    <td>{{ row.text.shortLabel }}</td>
                </tr>
            </tbody>
        </table>
    </aside>

    <section class="years-data">
        <table>
            <thead>
                <tr>
                    <th *ngFor="let label of overview.columnsLabels">
                        {{ label }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of overview.rows">
                    <td *ngFor="let column of row.columns">
                        {{ column.value | formatAmount }}
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</div>
